import { Trans, useTranslation } from '@e-kyc/translations';

function PreviewFrontOverlay() {
  const { t } = useTranslation();
  return (
    <div className='flex size-full flex-col'>
      <div className='h-[calc((100%-260px)/2)] w-full items-center justify-center' />
      <div className='flex h-[200px] w-full items-center justify-center'>
        <div className='h-full w-[calc((100%-320px)/2)]' />
        <div className='relative h-full w-[320px] rounded-xl shadow-[0_0_0_1000px_rgba(0,0,0,0.8)]' />
        <div className='h-full w-[calc((100%-320px)/2)]' />
      </div>
      <div className='z-10 flex w-full grow flex-col items-center justify-start p-4'>
        <h4 className='font-semibold text-white'>{t('preview.overlay.front.title')}</h4>
        <div className='text-body-2 flex flex-col items-center justify-center text-center text-white'>
          <Trans i18nKey='preview.overlay.description' />
        </div>
      </div>
    </div>
  );
}

export default PreviewFrontOverlay;
